import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'

import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['κερδίστε'],
    small: ['τροχό', 'δωρεάν'],
}

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')
    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }
    return (
        <HighlightedText
            text="Γυρίστε τον τροχό και κερδίστε δωρεάν περιστροφές"
            highlights={[{ word: 'δωρεάν' }, { word: 'περιστροφές' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
